<div class="pricing-backdrop">
  <div class="pricing-modal">
    <button class="close-btn" aria-label="Close" (click)="close()">
      <i class="bi bi-x-lg"></i>
    </button>

    <!-- IF TRUE -->
    <ng-container *ngIf="data.isVisible; else showJobTemplate">
      <h2 class="title text-center">
        Hide this job from BeExpert.ai student dashboard?
      </h2>

      <p class="text-center">
        Students will no longer see this job on the BeExpert.ai dashboard. Existing
        applications will not be affected.
      </p>

      <div class="btn-actions">
        <button class="btn-cancel m-0" (click)="close()">Cancel</button>

        <button class="btn-add m-0" (click)="confirmVisibilityChange(false)">
          Confirm
        </button>
      </div>
    </ng-container>

    <!-- IF FALSE -->
    <ng-template #showJobTemplate>
      <h2 class="title text-center">
        Show this job on BeExpert.ai student dashboard?
      </h2>

      <p class="text-center">
        Students browsing the BeExpert.ai dashboard will be able to view and apply
        to this job.
      </p>

      <div class="btn-actions">
        <button class="btn-cancel m-0" (click)="close()">Cancel</button>

        <button class="btn-add m-0" (click)="confirmVisibilityChange(true)">
          Confirm
        </button>
      </div>
    </ng-template>
  </div>
</div>